// Interface

import util from '@/utils/classToObject'
import { IUiState } from './state'

export class UiGetter {
    public snackMessages(state: IUiState) {
        return state.snackMessages
    } 
    public contentHeight(state: IUiState){
        return state.contentHeight
    }
    public errorMessages(state: IUiState) {
        return state.errorMessages
    }   

    public searchFlux(state: IUiState) {
        return state.searchFlux
    } 
    
    public sortFluxDesc(state: IUiState) {
        return state.sortFluxDesc
    }  

    public sortFluxBy(state: IUiState) {
        return state.sortFluxBy
    }  
    
    public searchPartenaire(state: IUiState) {
        return state.searchPartenaire
    } 

    public sortPartenaireDesc(state: IUiState) {
        return state.sortPartenaireDesc
    }   

    public sortPartenaireBy(state: IUiState) {
        return state.sortPartenaireBy
    }  public searchDataSource(state: IUiState) {
        return state.searchDataSource
    } 

    public sortDataSourceDesc(state: IUiState) {
        return state.sortDataSourceDesc
    }   

    public sortDataSourceBy(state: IUiState) {
        return state.sortDataSourceBy
    }  

    public searchFeedDownload(state: IUiState) {
        return state.searchFeedDownload
    } 

    public sortFeedDownloadDesc(state: IUiState) {
        return state.sortFeedDownloadDesc
    }   

    public sortFeedDownloadBy(state: IUiState) {
        return state.sortFeedDownloadBy
    }  
    public searchFluxBuilder(state: IUiState) {
        return state.searchFluxBuilder
    } 

    public sortFluxBuilderDesc(state: IUiState) {
        return state.sortFluxBuilderDesc
    }   

    public sortFluxBuilderBy(state: IUiState) {
        return state.sortFluxBuilderBy
    } 
    public searchMeta(state: IUiState) {
        return state.searchMeta
    } 

    public sortMetaDesc(state: IUiState) {
        return state.sortMetaDesc
    }   

    public sortMetaBy(state: IUiState) {
        return state.sortMetaBy
    }

    public searchPersonne(state: IUiState) {
        return state.searchPersonne
    } 

    public sortPersonneDesc(state: IUiState) {
        return state.sortPersonneDesc
    }   

    public sortPersonneBy(state: IUiState) {
        return state.sortPersonneBy
    } 

    public searchProfilExclusion(state: IUiState) {
        return state.searchProfilExclusion
    } 

    public sortProfilExclusionDesc(state: IUiState) {
        return state.sortProfilExclusionDesc
    }   

    public sortProfilExclusionBy(state: IUiState) {
        return state.sortProfilExclusionBy
    } 

    public searchGroupCarac(state: IUiState) {
        return state.searchGroupCarac
    } 

    public sortGroupCaracDesc(state: IUiState) {
        return state.sortGroupCaracDesc
    }   

    public sortGroupCaracBy(state: IUiState) {
        return state.sortGroupCaracBy
    } 

    public filterGrouId(state: IUiState) {
        return state.filterGrouId
    } 

    public filterDbName(state: IUiState) {
        return state.filterDbName
    } 

    public filterDbKey(state: IUiState) {
        return state.filterDbKey
    } 

    public filterType(state: IUiState) {
        return state.filterType
    } 

}

export default util.classToObject(UiGetter)